function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//@ts-nocheck

import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, { getName } from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import { imgPasswordInVisible } from "./assets";
// Customizable Area End

export const configJSON = require("./config");
const number_test = /^\d+$/;
const mobile_regex = /^(?:\d{12}|\w+@\w+\.\w{2,3})$/;
const email_mobile_Regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export default class EmailAccountLoginController extends BlockComponent {
  // Customizable Area End

  constructor(props) {
    super(props);
    // Customizable Area Start
    _defineProperty(this, "apiEmailLoginCallId", "");
    _defineProperty(this, "validationApiCallId", "");
    _defineProperty(this, "labelTitle", "");
    // Customizable Area Start
    _defineProperty(this, "handleEmailChange", event => {
      var _event$target;
      // const email_mobile_Regex=/^(?:\d{10}|\w+@\w+\.\w{2,3})$/
      if (number_test.test(event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value)) {
        var _event$target2;
        if (!mobile_regex.test(event === null || event === void 0 || (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.value)) {
          this.setState({
            email: event.target.value,
            isEmailValid: false,
            emailErrorMessage: "Please enter a valid email / mobile number."
          });
        } else {
          this.setState({
            email: event.target.value,
            isEmailValid: true,
            emailErrorMessage: ""
          });
        }
      } else {
        var _event$target3;
        if (!email_mobile_Regex.test(event === null || event === void 0 || (_event$target3 = event.target) === null || _event$target3 === void 0 ? void 0 : _event$target3.value)) {
          this.setState({
            email: event.target.value,
            isEmailValid: false,
            emailErrorMessage: "Please enter a valid email / mobile number."
          });
        } else {
          this.setState({
            email: event.target.value,
            isEmailValid: true,
            emailErrorMessage: ""
          });
        }
      }
    });
    _defineProperty(this, "handlePasswordChange", event => {
      this.setState({
        password: event.target.value
      });
    });
    _defineProperty(this, "handleRememberMeChange", event => {
      this.setState(prevState => ({
        checkedRememberMe: !prevState.checkedRememberMe
      }));
    });
    _defineProperty(this, "handleLoginClick", () => {
      if (this.state.email.length != 0 && this.state.isEmailValid) {
        this.doEmailLogIn();
      } else {
        if (this.state.email.length == 0) {
          this.setState({
            isEmailValid: false,
            emailErrorMessage: "Field cannot be blank."
          });
        }
      }
    });
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [getName(MessageEnum.CountryCodeMessage), getName(MessageEnum.RestAPIResponceMessage), getName(MessageEnum.ReciveUserCredentials)];
    this.state = {
      email: "",
      password: "",
      enablePasswordField: true,
      checkedRememberMe: false,
      placeHolderEmail: configJSON.placeHolderEmail,
      placeHolderPassword: configJSON.placeHolderPassword,
      imgPasswordVisible: configJSON.imgPasswordVisible,
      imgPasswordInVisible: imgPasswordInVisible,
      labelHeader: configJSON.labelHeader,
      btnTxtLogin: configJSON.btnTxtLogin,
      labelRememberMe: configJSON.labelRememberMe,
      btnTxtSocialLogin: configJSON.btnTxtSocialLogin,
      labelOr: configJSON.labelOr,
      isEmailValid: true,
      emailErrorMessage: ""
    };
    this.emailReg = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/;
    this.labelTitle = configJSON.labelTitle;
    // Customizable Area End

    runEngine.attachBuildingBlock(this, this.subScribedMessages);
  }
  async componentDidMount() {
    this.callGetValidationApi();
    this.send(new Message(getName(MessageEnum.RequestUserCredentials)));
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area End

  async receive(from, message) {
    // Customizable Area Start

    if (getName(MessageEnum.ReciveUserCredentials) === message.id) {
      const userName = message.getData(getName(MessageEnum.LoginUserName));
      const password = message.getData(getName(MessageEnum.LoginPassword));
      const countryCode = message.getData(getName(MessageEnum.LoginCountryCode));
      if (!countryCode && userName && password) {
        this.setState({
          email: userName,
          password: password,
          checkedRememberMe: true
        });
      }
    } else if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(getName(MessageEnum.RestAPIResponceDataMessage));
      var responseJson = message.getData(getName(MessageEnum.RestAPIResponceSuccessMessage));
      var errorReponse = message.getData(getName(MessageEnum.RestAPIResponceErrorMessage));
      if (apiRequestCallId != null) {
        if (apiRequestCallId === this.validationApiCallId && responseJson !== undefined) {
          var arrayholder = responseJson.data;
          if (arrayholder && arrayholder.length !== 0) {
            let regexData = arrayholder[0];
            if (regexData && regexData.email_validation_regexp) {
              this.emailReg = new RegExp(regexData.email_validation_regexp);
            }
          }
        }
        if (apiRequestCallId === this.apiEmailLoginCallId) {
          if (responseJson && responseJson.meta && responseJson.meta.token) {
            const dateString = new Date();
            localStorage.removeItem("fireBaseToken");
            localStorage.setItem("token", responseJson.meta.token);
            localStorage.setItem("tokenExpire", dateString.toISOString());
            localStorage.setItem("userInfo", JSON.stringify(responseJson.account));
            localStorage.setItem("userId", responseJson.account.data.id);
            this.props.navigation.navigate("Dashboard");
            // runEngine.unSubscribeFromMessages(this, this.subScribedMessages);
            // this.saveLoggedInUserData(responseJson);
            // this.sendLoginSuccessMessage();
            // this.openInfoPage();
          } else {
            //Check Error Response
            this.parseApiErrorResponse(responseJson);
            this.sendLoginFailMessage();
          }
          this.parseApiCatchErrorResponse(errorReponse);
        }
      }
    }
    // Customizable Area End
  }
  sendLoginFailMessage() {
    const msg = new Message(getName(MessageEnum.LoginFaliureMessage));
    this.send(msg);
  }
  sendLoginSuccessMessage() {
    const msg = new Message(getName(MessageEnum.LoginSuccessMessage));
    msg.addData(getName(MessageEnum.LoginUserName), this.state.email);
    msg.addData(getName(MessageEnum.CountyCodeDataMessage), null);
    msg.addData(getName(MessageEnum.LoginPassword), this.state.password);
    msg.addData(getName(MessageEnum.LoginIsRememberMe), this.state.checkedRememberMe);
    this.send(msg);
  }
  saveLoggedInUserData(responseJson) {
    if (responseJson && responseJson.meta && responseJson.meta.token) {
      const msg = new Message(getName(MessageEnum.SessionSaveMessage));
      msg.addData(getName(MessageEnum.SessionResponseData), JSON.stringify(responseJson));
      msg.addData(getName(MessageEnum.SessionResponseToken), responseJson.meta.token);
      this.send(msg);
    }
  }
  openInfoPage() {
    const msg = new Message(getName(MessageEnum.AccoutLoginSuccess));
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(msg);
  }
  goToForgotPassword() {
    const msg = new Message(getName(MessageEnum.NavigationForgotPasswordMessage));
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this === null || this === void 0 ? void 0 : this.props);
    msg.addData(getName(MessageEnum.NavigationForgotPasswordPageInfo), "email");
    this === null || this === void 0 || this.send(msg);
  }
  goToSocialLogin() {
    const msg = new Message(getName(MessageEnum.NavigationSocialLogInMessage));
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(msg);
  }
  doEmailLogIn() {
    // const email_mobile_Regex=/^(?:\d{10}|\w+@\w+\.\w{2,3})$/
    if (number_test.test(this.state.email)) {
      if (!mobile_regex.test(this.state.email)) {
        this.showAlert("Error", configJSON.errorEmailNotValid);
        return false;
      }
    } else {
      if (!email_mobile_Regex.test(this.state.email)) {
        this.showAlert("Error", "Not a valid Number");
        return false;
      }
    }

    // if (
    //   this.state.email === null ||
    //   this.state.email.length === 0 ||
    //   !email_mobile_Regex.test(this.state.email)
    // ) {
    //   this.showAlert("Error", configJSON.errorEmailNotValid);
    //   return false;
    // }

    if (this.state.password === null || this.state.password.length === 0) {
      this.showAlert("Error", configJSON.errorPasswordNotValid);
      return false;
    }
    const header = {
      "Content-Type": configJSON.loginApiContentType
    };
    const email_data = {
      type: "email_account",
      email: this.state.email,
      password: this.state.password
    };
    const mobile_data = {
      type: "sms_account",
      full_phone_number: this.state.email,
      password: this.state.password
    };
    const httpBody = {
      data: this.state.email.includes("@") ? email_data : mobile_data
    };
    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.apiEmailLoginCallId = requestMessage.messageId;
    requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.loginAPiEndPoint);
    requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
    requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), JSON.stringify(httpBody));
    requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.loginAPiMethod);
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return true;
  }
  callGetValidationApi() {
    const headers = {
      "Content-Type": configJSON.validationApiContentType
    };
    const getValidationsMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.validationApiCallId = getValidationsMsg.messageId;
    getValidationsMsg.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.urlGetValidations);
    getValidationsMsg.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(headers));
    getValidationsMsg.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.validationApiMethodType);
    runEngine.sendMessage(getValidationsMsg.id, getValidationsMsg);
  }
}